export default "__VITE_ASSET__26ec0e03__"